import {
  GET_ADDEMPLOYEE,
  GET_EMPLOYEEDETAILS,
  GET_EMPLOYEESLIST,
  GET_UPDATEEMPLOYEE,
  UPLOAD_EMPLOYEE_EXCEL,
  APPROVE_EMPLOYEE,
} from "resources/actionTypes";

export function getEmployeesList(payloadData) {
  return {
    type: GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_REQUESTED,
    payload: payloadData,
  };
}

export function getEmployeeDetails(payloadData) {
  return {
    type: GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_REQUESTED,
    payload: payloadData,
  };
}

export function clearEmployeeDetails() {
  return {
    type: GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_RESET,
  };
}

export function addEmployee(employeeData, navigate) {
  const data = {
    employeeData: employeeData,
    navigate: navigate,
  };

  return {
    type: GET_ADDEMPLOYEE.GET_ADDEMPLOYEE_REQUESTED,
    payload: data,
  };
}

export function updateEmployee(employeeData, id, navigate) {
  const data = {
    employeeData: employeeData,
    employeeId: id,
    navigate: navigate,
  };

  return {
    type: GET_UPDATEEMPLOYEE.GET_UPDATEEMPLOYEE_REQUESTED,
    payload: data,
  };
}

export function uploadEmployeeExcel(file, companyId) {
  return {
    type: UPLOAD_EMPLOYEE_EXCEL.UPLOAD_EMPLOYEE_EXCEL_REQUESTED,
    payload: {
      file,
      companyId,
    },
  };
}

export function approveEmployee(payloadData) {
  return {
    type: APPROVE_EMPLOYEE.APPROVE_EMPLOYEE_REQUESTED,
    payload: payloadData,
  };
}
